import React from "react";
import moment from "moment";
import { Form, DatePicker } from "antd";
import dayjs from "dayjs";
import { createUseStyles } from "react-jss";

const UIDatePicker = ({
  label,
  required,
  rules,
  onChange,
  validateStatus,
  hasFeedback,
  help,
  disabled,
  name,
  defaultValue,
  placeholder = "",
  fieldType,
  disableprevdate = false,
}) => {
  const styles = useStyles();

  return (
    <Form.Item
      label={<span style={{ fontSize: "16px", fontWeight: "500" }}>{label}</span>}
      name={name}
      required={required}
      rules={rules}
      hasFeedback={hasFeedback}
      help={help}
      validateStatus={validateStatus}
      initialValue={defaultValue ? dayjs(defaultValue) : undefined}
    >
      <DatePicker
        showTime={fieldType === "DateTimePicker"}
        format={fieldType === "DateTimePicker" ? "YYYY-MM-DD HH:mm:ss a" : "MMMM DD YYYY"}
        className={styles.customSelect}
        placeholder={placeholder}
        disabled={disabled}
        onChange={(date, dateString) => {
          if (typeof onChange === "function") onChange(date, dateString);
        }}
        disabledDate={(current) => {
          if (disableprevdate) {
            return current && current < moment().subtract(1, "days");
          }
          return false;
        }}
      />
    </Form.Item>
  );
};

export default UIDatePicker;

const useStyles = createUseStyles({
  customSelect: {
    width: "100%",
    height: "51px !important",
  },
});
